// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".c1520a80578301dfdc0ecd9eeda5528518de718c.chunk.bundle.js";
};